import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import router from "./router";
import { Container, Draggable } from "vue-smooth-dnd";

//import SocketService from './common/socket.service'

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["grid", "c"];

//SocketService.init()

import VueSocketio from "vue-socket.io-extended";
import io from "socket.io-client";
import VModal from "vue-js-modal";
import { BASE_API_URL, BASE_URL } from "@/common/urls";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faAlignLeft,
  faWindowClose,
  faSave,
  faTimes,
  faArchive,
  faPaperPlane,
  faHistory,
  faPaperclip,
  faSun,
  faMoon,
  faFileUpload,
  faCopy,
  faBars,
  faEllipsisV,
  faSignOutAlt,
  faCalendar,
  faCog
} from "@fortawesome/free-solid-svg-icons";
import { faComment as farComment } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//import axios from "axios";

import Autocomplete from "v-autocomplete";

import { SET_WINDOW_SIZE } from "@/store/actions.type";

import Snotify, { SnotifyPosition } from "vue-snotify";

const order = require("./common/utils.order");

//axios.defaults.withCredentials = true;

Vue.prototype.$order = order.default;
Vue.prototype.$eventHub = new Vue(); // Global event bus

library.add(
  faPlus,
  faAlignLeft,
  faWindowClose,
  faSave,
  faTimes,
  faArchive,
  faPaperPlane,
  faHistory,
  faPaperclip,
  faSun,
  faMoon,
  faFileUpload,
  faCopy,
  faBars,
  faEllipsisV,
  faSignOutAlt,
  faCalendar,
  faCog
);
library.add(farComment);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("Container", Container);
Vue.component("Draggable", Draggable);

import Spinner from "@/components/general/Spinner.vue";
import Button from "@/components/Button.vue";
import TextareaAutosize from "@/components/general/TextareaAutosize.vue";
Vue.component("Spinner", Spinner);
Vue.component("Button", Button);
Vue.component("TextareaAutosize", TextareaAutosize);

if (process.env.NODE_ENV != "production") {
  console.log("NODE_ENV = " + process.env.NODE_ENV);
  console.log("BASE_API_URL = " + BASE_API_URL);
  console.log("BASE_URL = " + BASE_URL);
}

Vue.use(
  VueSocketio,
  // eslint-disable-next-line no-undef
  io(BASE_API_URL),
  { store }
);

Vue.use(Autocomplete);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightBottom
  }
});

var cursorX;
var cursorY;

function endDrag(x, y) {
  var ev = document.createEvent("MouseEvent");
  var el = document.elementFromPoint(x, y);

  ev.initMouseEvent(
    "mouseup",
    true /* bubble */,
    true /* cancelable */,
    window,
    null,
    x,
    y,
    0,
    0 /* coordinates */,
    false,
    false,
    false,
    false /* modifier keys */,
    0 /*left*/,
    null
  );
  el.dispatchEvent(ev);
}

import { GLOBAL_BASE_URL } from "./common/urls";

const app = new Vue({
  store,
  router,
  render: h => h(App),
  mounted() {
    // eslint-disable-next-line no-undef

    this.$store.dispatch("users/startup");

    //this.$store.commit(SET_WINDOW_SIZE, window);

    window.addEventListener("resize", () => {
      this.$store.commit(SET_WINDOW_SIZE, window);
    });

    document.onmousemove = function(e) {
      cursorX = e.pageX;
      cursorY = e.pageY;
    };

    window.addEventListener("keydown", event => {
      if (event.code == "Escape") {
        if (store.getters.isDragging) {
          store.commit("STOP_ANY_DRAG");
          endDrag(cursorX, cursorY);
          return;
        }

        this.$eventHub.$emit("command-cancel");
        return;
      }
      if (event.code == "Enter") {
        const isCmd = event.ctrlKey || event.metaKey;
        if (isCmd) {
          this.$eventHub.$emit("command-save");
        }
      }
    });
  }
});

app.$mount("#app");
